import styled from 'styled-components';
import { LineScoreWrapper, StyledInningCell } from '@mlb/react-patterns/v4/components/LineScore/lineScore.style';
import { StyledBaseSkeleton } from '@mlb/react-patterns/v4/components/Skeleton/skeleton.style';
import { StyledTable, TableScroller } from '@mlb/react-patterns/v4/components/Table/table.style';
import {
    DesktopRecordWrapper,
    DesktopStandingsWrapper,
    DataWrapper,
    NameWrapper
} from '@mlb/react-patterns/v4/components/Team/team.style';
import { BoxscoreTabsWrapper, BoxscoreWrapper, BoxScrollWrapper } from '../Boxscore/Boxscore.style';
import { TeamTableWrapper } from '../Boxscore/boxscore/boxscoreTeam/BoxscoreTeamTable.style';
import { GamedayLineScoreWrapper } from '../LineScore/LineScore.style';
import { TabsWrapper } from '../Tabs/Tabs.style';
import {
    GameStateWrapper,
    SkeletonWrapper as TeamSummaryMatchupSkeletonWrapper,
    TeamSummaryMatchUpWrapper
} from '../TeamSummaryMatchup/TeamSummaryMatchup.style';
import { SummaryPlayListWrapper, FiltersInnerWrapper, Divider } from '../Summary/summary.style';
import { finalViewsTypes } from '../themes/finalViewsTypes';
import {
    HighlightVideoPlayerWrapper,
    HighlightCardListWrapper,
    HeadlineTitleWrapper,
    HeadlineDescriptionWrapper,
    HighlightVideoHeadlineWrapper,
    HighlightVideoPlayerSkeleton
} from '../HighlightsPlaylist/HighlightsPlaylist.style';
import { VideoPlayerWrapper, VideoThumbnailWrapper } from '../VideoPlayer/VideoPlayer.style';
import { LineScoreDecisionsWrapper } from './final/LineScoreDecisions.style';
import { GDBREAKPOINTS_FINAL } from '../themes/breakpoints';
import { CardWrapper } from '../Card/Card.style';

const { MD_MIN, MD_MAX, SM_MAX } = GDBREAKPOINTS_FINAL;
const { SINGLENARROW, SINGLEWIDE, TWOCOLS } = finalViewsTypes;

const GameStateFontSize = {
    [TWOCOLS]: {
        EXPANDED: '20px',
        DEFAULT: '16px'
    },
    [SINGLEWIDE]: {
        EXPANDED: '16px',
        DEFAULT: '14px'
    },
    [SINGLENARROW]: {
        DEFAULT: '14px'
    }
};

export const FinalWrapper = styled.div`
    color: var(--gameday-primary-font-color);
    font-family: var(--gameday-primary-font);
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    flex: 1 1 100%;
    height: 100%;
    display: flex;
    ${({ $viewType }) => {
        if ($viewType === SINGLENARROW || $viewType === SINGLEWIDE) {
            return `
                    display: block;
                `;
        }
    }};
    ${BoxscoreWrapper} {
        margin-bottom: 0px;
        ${BoxScrollWrapper} {
            padding: 0px var(--gameday-section-padding-sm) var(--gameday-section-padding-sm);
        }
      }
    ${BoxscoreTabsWrapper} {
        padding-top: 16px;
        padding-bottom: 4px;
    }
    ${TeamTableWrapper} {
        margin-right: calc(var(--gameday-section-padding-sm) * -1);
    }
    ${StyledTable} {
        padding-right: var(--gameday-section-padding-sm);
    }

    ${SummaryPlayListWrapper} {
        padding: 16px 16px 0;
    }

    ${TeamSummaryMatchupSkeletonWrapper} {
        border-bottom: none;
        ${({ $viewType }) => {
            if ($viewType === TWOCOLS) {
                return `
                        height: 48px;
                    `;
            }
        }};
    }

    ${TeamSummaryMatchUpWrapper} {
        border-bottom: 1px solid var(--gameday-divider-color);
        ${DataWrapper} {
            display: flex;
            flex-direction: column;
        }

        ${NameWrapper} {
            margin-right: 0;
            margin-left: 0;
        }
        ${GameStateWrapper} {
            font-size: ${({ $viewType, $expanded }) => GameStateFontSize[$viewType][$expanded ? 'EXPANDED' : 'DEFAULT']};
            line-height:${({ $viewType, $expanded }) => GameStateFontSize[$viewType][$expanded ? 'EXPANDED' : 'DEFAULT']};
        }
    }

    ${FiltersInnerWrapper} {
        padding: 0px 16px;
        margin-top: 16px;
    }

    ${Divider} {
        margin: 0px;
    }

    ${TabsWrapper} {
        >div {
            padding: 0px;
        }

        padding: 16px;
        >div {
            button {
                margin: 0px;
                margin-right: 24px;
                font-size: 20px;
                font-weight: 700;
            }
        }
        [data-selected=true] {
            span {
                color: var(--gameday-primary-font-color);
                border-color: var(--gameday-primary-font-color);
            }
        }
        ${({ $viewType }) => {
        if ($viewType === SINGLENARROW) {
            return `
                    background: var(--gameday-background-color);
                    border-bottom: 1px solid var(--gameday-wrap-section-divider);
                `;
        } else if ($viewType === TWOCOLS) {
            return `
                    padding: 0px 32px;
                `;
        } else if ($viewType === SINGLEWIDE) {
            return `
                    padding: 16px 32px 0px;
                `;
        }
    }};
    }
    >${StyledBaseSkeleton} {
        margin-top: 35px;
        margin-left: var(--gameday-section-padding-auto);
        margin-bottom: 20px;
    }

    ${DesktopRecordWrapper} {
        color: var(--gameday-decisions-stats-color);
    }
    ${NameWrapper}, ${DesktopStandingsWrapper} {
        color: var(--gameday-primary-font-color);
    }

    ${BoxscoreTabsWrapper} {
        padding: 8px var(--gameday-section-padding-sm);
        >div {
            padding-bottom: 0px;
        }
    }

    ${HighlightCardListWrapper} {
        padding-bottom: 16px;
    }

    ${HighlightVideoPlayerWrapper} {
        @media (min-width: ${MD_MIN}) {
            ${HighlightVideoHeadlineWrapper} {
                row-gap: 8px;
            }
            ${HeadlineTitleWrapper} {
                font-size: 18px;
                line-height: 27px;
            }
            ${HeadlineDescriptionWrapper} {
                font-size: 16px;
                line-height: 24px;
            }
            ${VideoPlayerWrapper},
            ${VideoThumbnailWrapper},
            ${HighlightVideoPlayerSkeleton} {
                margin: 16px 16px 0;
                width: calc(100% - 32px);
            }
        }
    }
`;

export const FinalLinescoreWrapper = styled.div`
    ${LineScoreDecisionsWrapper} {
        ${GamedayLineScoreWrapper} {
            border-bottom: 1px solid var(--gameday-divider-color);
            ${LineScoreWrapper} {
                display: flex;
                justify-content: space-between;
                max-width: 100%;
                >div {
                    overflow: visible;
                    &:first-child {
                        flex-basis: 77%;
                        ${TableScroller} {
                            margin-left: 40px;
                        }
                    }
                    &:last-child {
                        flex-basis: 23%;
                        margin-right: -8px;
                    }
                }
            }
        }
    }
    ${({ $expanded, $twoColumnExpandView, $singleColumnExpandView }) => {
        let temp = '';
        if ($expanded) {
            temp += `
            ${LineScoreDecisionsWrapper} {
                ${GamedayLineScoreWrapper} {
                        border-bottom: none;
                        padding: 0;
                }
            }`;
        } if ($singleColumnExpandView) {
            temp += `
            ${LineScoreDecisionsWrapper} {
                ${GamedayLineScoreWrapper} {
                    ${LineScoreWrapper} {
                        >div:first-child {
                            ${TableScroller} {
                                margin-left: 40px;
                            }
                        }
                        >div:last-child {
                            flex-basis: 23%;
                            margin-right: -8px;
                        }
                    }
                }
            }`;
        } if ($twoColumnExpandView) {
            temp += `
                ${LineScoreDecisionsWrapper} {
                    ${GamedayLineScoreWrapper} {
                        ${LineScoreWrapper} {
                            >div:first-child {
                                flex-basis: 65%;
                                ${TableScroller} {
                                    margin-left: 135px;
                                    table {
                                        tbody {
                                            tr{
                                                th {
                                                    ${StyledInningCell} {
                                                        text-align: right;
                                                        width: 130px;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            >div:last-child {
                                flex-basis: 19%;
                            }
                        }
                    }
                }`;
        }
        return temp;
    }
}
`;

export const SingleColTeamCompWrapper = styled.div`
    border-bottom: 1px solid var(--gameday-wrap-section-divider);
    background: var(--gameday-background-color);
    padding-bottom: var(--gameday-section-padding-sm);
`;

export const Col = styled.div`
    position: relative;
    height: 100%;
`;

export const TwoColWrapper = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
    width: 100%; // FF has issues with implicit layouts
`;

export const SideViewCard = styled(CardWrapper).attrs(({ $viewType }) => {
    return { $displayFlat: $viewType === SINGLENARROW };
})`
    max-height: calc(100% - 48px);
    display: flex;
    flex-direction: column;
    position: absolute;
    max-width: calc(100% - 32px);
    width: 100%;
    right: 0;
    margin-bottom: 24px;
    padding: 0;
    background: var(--gameday-background-color);
    @media (max-width: ${MD_MAX}) {
        padding: 8px 0px;
        margin-top: 16px;
        max-height: 100%;
        overflow: auto;
        display: block;
        position: relative;
    }
    @media (max-width: ${SM_MAX}) {
        margin: 0;
        padding: 0;
        max-width: 100%;
    }
`;

export const FinalCompWrapper = styled(CardWrapper).attrs(({ $viewType }) => {
    return { $displayFlat: $viewType === SINGLENARROW };
})`
    background: var(--gameday-background-color);
    @media (min-width: ${MD_MIN}) {
        margin-top: 16px;
    }
`;
